module.exports = __webpack_public_path__ + "static/media/Slide3.66e86cdc.png";